import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomPageConfigService, AuthService } from 'gung-standard';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecCustomPageConfigService extends CustomPageConfigService {
  constructor(protected http: HttpClient, protected authService: AuthService) {
    super(http, authService);
  }

  public getDefaultTemplate(type?): Observable<any[]> {
    return super.getDefaultTemplate(type).pipe(
      map(templates => {
        templates.push({
          id: 'colmechomedefault',
          name: 'COLMEC_STARTPAGE'
        });
        return templates;
      })
    );
  }
}
